import { debounce, onKeyUpEscape } from '../js/global-exports.js';

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.initAdjustFacetDisplayPosition();
    this.controlZIndexWhenOpen();
  }

  controlZIndexWhenOpen() {
    //on mobile
    if(!this.querySelector('#FacetFiltersFormMobile')) {return;}
    const filterDetails = document.querySelectorAll('.mobile-facets__disclosure.disclosure-has-popup');
    for (let i = 0; i < filterDetails.length; i++) {
      const detail = filterDetails[i];
    detail.addEventListener('toggle', (e) => {
        const facetsContainer = e.target.closest('.facets-container');
        if(e.target.hasAttribute('open')) {
          facetsContainer.classList.add('facets-container--active')
        } else {
          facetsContainer.classList.remove('facets-container--active')
        }
      })
    }
  }

  initAdjustFacetDisplayPosition() {
    //on desktop
    const filterDetails = this.querySelectorAll('details.disclosure-has-popup.facets__disclosure');
    for (let i = 0; i < filterDetails.length; i++) {
      const detail = filterDetails[i];

      detail.addEventListener('toggle', (e) => {
        this.recalcFacetDisplayPosition(e.target);
       })
    }

    window.addEventListener('resize', debounce(() => {
      const openFacetDetails = this.querySelectorAll('details.disclosure-has-popup.facets__disclosure[open]');
      for (let j = 0; j < openFacetDetails.length; j++) {
        const openFacetDetail = openFacetDetails[j];
        this.recalcFacetDisplayPosition(openFacetDetail);
      }
    },150));
  }

  recalcFacetDisplayPosition (thisDetail) {
    if(thisDetail.hasAttribute('open')) {
      const facetDisplay = thisDetail.querySelector('.facets__display');
      facetDisplay.setAttribute('style','');//reset styles
      var facetDisplayRight = facetDisplay.getBoundingClientRect().right;
      var bodyWidth = document.body.offsetWidth - 50;//due to padding
      if(facetDisplayRight > bodyWidth) {//if box goes out of screen on right side, adjust for it
        var styleOfFacetDisplay = facetDisplay.currentStyle || window.getComputedStyle(facetDisplay);
        const facetDisplayLeft = parseInt(styleOfFacetDisplay.left, 10);
        const facetDisplayNewLeft = facetDisplayLeft - (facetDisplayRight - bodyWidth);

        facetDisplay.style.left = `${facetDisplayNewLeft}px`;
      }
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    document.getElementById('ProductGridContainer').querySelector(':scope > .loading-overlay').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
      FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static waitingAnimationResultNumber() {
    const numberHolders = Array.from(document.getElementsByClassName('mobile-facets__result-number'));
    numberHolders.forEach((el) => {
      el.classList.add('mobile-facets__result-number--loading')
    })
  }

  static renderSectionFromFetch(url, event) {
    this.waitingAnimationResultNumber();
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const countElem = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const count = countElem.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const containersMobile = document.getElementById('js-ProductCountMobile');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }

    if (containersMobile) {
      for (let i = 0; i < containersMobile.length; i++) {
        const element = containersMobile[i];
        element.innerHTML = countElem.dataset.count;
        element.classList.remove('loading');
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      if(selector === '.mobile-facets__count') {
        const btnContent = html.querySelector(selector).innerHTML;
        document.querySelectorAll(selector).forEach(
          (el) => {
            el.innerHTML = btnContent;
          }
        );
      } else {
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      }
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    FacetFiltersForm.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);


class ListViewPicker extends HTMLElement {
  constructor() {
    super();
    const radios = this.getElementsByClassName('list-view-picker__radio');
    let pickerTypes = [];

    for(let i = 0; i < radios.length;i+=1) {
      const radio = radios[i];
      pickerTypes.push(radio.name)
      radio.addEventListener('input', (event) => {
        event.stopPropagation();
        this.setListViewPreference(event.target);
      });
    }
    pickerTypes = pickerTypes.filter((value, index, self)=>{return self.indexOf(value) === index;});
    for(let j = 0; j < pickerTypes.length;j+=1) {
      this.actionsFromCookie(pickerTypes[j]);
    }
  }

  setListViewPreference(el) {
    const CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + 1);
    if(el.name !== null && el.name !== undefined && /^[a-zA-Z]|-+$/.test(el.name) && el.value !== null && el.value !== undefined && /^[a-zA-Z]|-+$/.test(el.value)){
      document.cookie = `${el.name}=${el.value}; expires=${CookieDate.toUTCString()};`;
    }
    this.listViewPickerActions(el.name,el.value)
  }

  cleanPickerType(pickerType) {
    return pickerType.replace('-mobile','');
  }

  actionsFromCookie(argPickerType){
    const pickerType = this.cleanPickerType(argPickerType)
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${pickerType}=`);
    if (parts.length === 2) {
      const cookieValue = parts.pop().split(';').shift();
      this.listViewPickerActions(pickerType, cookieValue);
    }else{
      const firstRadio = this.querySelector('.list-view-picker__radio');
      if(firstRadio) {
        firstRadio.checked = true;
      }
    }
  }

  listViewPickerActions(argPickerType, pickerValue){
    const pickerType = this.cleanPickerType(argPickerType)
    const productGridContainer = document.getElementById('ProductGridContainer');
    const productCollection = productGridContainer.closest('.collection');

    if(pickerType === 'list-view-picker-list-grid-view') {
      if(pickerValue === 'list') {
        productCollection.classList.add('collection--list-view')
      }else if(pickerValue === 'grid') {
        productCollection.classList.remove('collection--list-view')

      }
    }

    document.querySelector(`[name="${pickerType}"][value="${pickerValue}"]`).checked=true;
  }
}

customElements.define('list-view-picker', ListViewPicker);
